<template>
  <CardContainer :cardTitle="title" :isEmptyData="isLoaded && dataSource != null && dataSource.dataset.length === 0" :titleId="'line-chart-' + index" :participantName="dataParticipantName" :primaryColor="primaryColor" :choosenAnswers="choosenAnswers">
    <div slot="body">
      <fusioncharts type="msline" width="100%" height="350" dataFormat="json" :dataSource="dataSource"> </fusioncharts>
    </div>
  </CardContainer>
</template>
<script>
import _ from "lodash";
import CardContainer from "./card-container";
import { generateLineChartCard } from "../../services/utils";
import { optionsLineChart } from "../../services/chart-config";

export default {
  props: {
    index: [String, Number],
    title: { type: String, default: "Default Title" },
    isLoaded: { type: Boolean, default: false },
    dataSources: [Array, null],
    primaryColor: { type: String, default: "" },
    dataParticipantName: { type: String, default: "" }
  },
  components: {
    CardContainer
  },
  data() {
    return {
      dataSource: null,
      choosenAnswers: []
    };
  },
  methods: {
    processVisualization() {
      const clonedOptions = _.cloneDeep(optionsLineChart);
      const { categories, datasets, choosenAnswers } = generateLineChartCard(this.dataSources, this.primaryColor, this.dataParticipantName);
      this.choosenAnswers = choosenAnswers;
      clonedOptions.categories.push({ category: categories });
      clonedOptions.dataset = [...datasets];

      this.dataSource = clonedOptions;
    }
  },
  mounted() {
    this.processVisualization();
  }
};
</script>
